// 查询条件
import React, {Component} from "react";
import {connect} from "react-redux";
import "./index.less";
import {Form, Select} from "antd";
import antdEx from "icsoc-antd-ex";
import {bindActionCreators} from "redux";

const {
  ExTable: {Filter}
} = antdEx;

import actions from "Actions/taskManage/monitoring";

const {Option} = Select;

const NormalFilter = Filter.NormalFilter;

class Query extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
    // 项目名称
    this.postTasksListAllFun();
  }

  // 初始化项目列表
  initListFun=(data)=>{
    // 当前项目下列表
    const {Actions} = this.props;
    let param = {
      taskId:data[0].taskId ? data[0].taskId : '',   //项目Id
      minuteStr: '',
    };
    Actions.postCallbackByProId(param);
  }

  // 项目名称
  postTasksListAllFun = () => {
    const {Actions} = this.props;
    Actions.getTasksListAll().then(
      res=>{
        let data = res.payload.data;
        if(data && data.length > 0){
          Actions.setMonitoringId(data[0].taskId);
          this.initListFun(data);
        }
      },
      err=>{
      }
    );
  }

  // 搜索
  handleFilter = (fields) => {
    // 查询的回调。
    // fields 是控件的值。
    // type 有两个值，分别为 normal 和 advanced。
    // normal 是查询左侧普通搜索和更多搜索，advanced 是查询高级搜索。
    // 此处查询条件指的是所有
    const {Actions} = this.props;
    let param = {
      minuteStr: '',
      taskId: fields['taskId'],   //项目Id
    };
    Actions.setMonitoringId(fields.taskId);
    Actions.postCallbackByProId(param);
  };

  render() {
    const {taskManageMonitoring: {tasksDataList = []} } = this.props;
    const {} = this.state;
    return (
      <Filter
        className="am-query"
        handleFilter={this.handleFilter}
      >
        <NormalFilter>
          <NormalFilter.Item
            label="项目名称"
            initialValue= {tasksDataList.length>0 ? tasksDataList[0].taskId : null}
            field="taskId">
            <Select
              placeholder="项目名称"
              showSearch
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {tasksDataList.map((v, i) => {
                return (
                  <Option value={v.taskId}>
                   {v.taskName}
                  </Option>
                );
              })}
            </Select>
          </NormalFilter.Item>
        </NormalFilter>
      </Filter>
    );
  }
}

const mapStateToProps = state => ({
  taskManageMonitoring: state.taskManageMonitoring,
});

const mapDispatchToProps = dispatch => {
  return {
    Actions: bindActionCreators(actions, dispatch)
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(Form.create()(Query));
